import { useEffect, useState } from "react";
import { Form, Button, Container } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import axios from "../../../axios/axios";
import { message } from "antd";
import "./customer-facing.css";
import LoadingOverlay from "react-loading-overlay";
import {dream_vacation_embedde} from "../../../assets/images"
const TravelDashboardPart = () => {
  const location = useLocation();
  const { certificateId, sender_id, source_domain } = useParams();
  // Parse query parameters
  const queryParams = new URLSearchParams(location.search);
  const senderFrom = queryParams.get("send_from_code");

  const [certificateDetails, setCertificatedetails] = useState({});
  const [input, setInput] = useState({
    first_name: "",
    last_name: "",
    email: "",
    tviAdvantageSenderName: "",
    tviAdvantageSenderEmail: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCertificateDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [certificateId]);

  const getCertificateDetails = () => {
    setLoading(true);
    axios
      .get(`/get-certificate-details/${certificateId}`)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setCertificatedetails(res.data.certificateDetails);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        message.error("Something went wrong!!");
      });
  };

  const handleOnChange = (e) => {
    let { name, value } = e.target;

    setInput({
      ...input,
      [name]: value,
    });
  };

  const formSubmit = (e) => {
    e.preventDefault();

    let data = {
      ...input,
      certificateId,
      sender_id,
      source_domain,
    };
    setLoading(true);

    axios
      .post("/send-embed-certificate", data)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          setInput({
            first_name: "",
            last_name: "",
            email: "",
            tviAdvantageSenderName: "",
            tviAdvantageSenderEmail: "",
          });
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        message.error("Something went wrong!!");
      });
  };

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <Container>
        <Form onSubmit={formSubmit} className="p-5">
          {certificateDetails.certificateId === "TVIDREAMVAC" && (
            <div>
              <img src={dream_vacation_embedde} alt="" style={{width:"100%"}} />
            </div>
          )}
          <h3>{certificateDetails.certificateTitle}</h3>

          <Form.Control
            type="text"
            placeholder="First Name"
            className="customer_field mb-3"
            required
            value={input.first_name}
            name="first_name"
            onChange={handleOnChange}
          />

          <Form.Control
            type="text"
            placeholder="Last Name"
            className="customer_field mb-3"
            required
            value={input.last_name}
            name="last_name"
            onChange={handleOnChange}
          />

          <Form.Control
            type="email"
            placeholder="Email Address"
            className="customer_field mb-3"
            required
            value={input.email}
            name="email"
            onChange={handleOnChange}
          />

          {senderFrom && (
            <>
              <Form.Control
                type="text"
                placeholder="Sender Name"
                className="customer_field mb-3"
                required
                name="tviAdvantageSenderName"
                onChange={handleOnChange}
                value={input.tviAdvantageSenderName}
              />

              <Form.Control
                type="email"
                placeholder="Sender Email Address"
                className="customer_field mb-3"
                required
                name="tviAdvantageSenderEmail"
                onChange={handleOnChange}
                value={input.tviAdvantageSenderEmail}
              />
            </>
          )}

          <Button type="submit" className="d-block">
            SUBMIT
          </Button>

          {/* <Row>
          <Col md="3">
            <Form.Control
              type="text"
              placeholder="First Name"
              className="customer_field"
              required
              name="first_name"
              onChange={handleOnChange}
            />
          </Col>
          <Col md="3">
            <Form.Control
              type="text"
              placeholder="Last Name"
              className="customer_field"
              required
              name="last_name"
              onChange={handleOnChange}
            />
          </Col>
          <Col md="3">
            <Form.Control
              type="email"
              placeholder="Email Address"
              className="customer_field"
              required
              name="email"
              onChange={handleOnChange}
            />
          </Col>
          <Col md="3">
            <Button type="submit" className="d-block">
              SUBMIT
            </Button>
          </Col>
        </Row> */}
        </Form>
      </Container>
    </LoadingOverlay>
  );
};

export default TravelDashboardPart;
